<template>
  <div
    :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'"
    class="appDetailsNest"
  >
    <div style="padding: 15px" class="mingxi">
      <div class="title">
        <p class="name">回测统计明细</p>
        <p class="right"></p>
      </div>

      <div class="fc-title-sticky">
        <ul class="fc-title">
          <li></li>
          <li>持有期</li>
          <li>区间均涨幅</li>
          <li>盈亏比</li>
          <li style="text-align: right">上涨概率</li>
        </ul>
      </div>
      <ul class="list" v-for="(item, index) in BacktestAnalysisResult" :key="item.HoldPeriod">
        <li class="zybox-list-left">
          <p class="excellent" v-if="maxAvgSectionRateIndex === index">涨幅</p>

          <p class="probability" v-if="maxRiseProbabilityIndex === index">概率</p>
        </li>

        <li>{{ item.HoldPeriod }}天</li>
        <li :class="[judgeColor(item.AvgSectionRate)]">
          {{ toFixedNum(item.AvgSectionRate * 100, 2, '%') }}
        </li>
        <li>
          {{ toFixedNum(item.ProfitLossRatio, 2, '') }}
        </li>
        <li style="text-align: right">{{ toFixedNum(item.RiseProbability * 100, 2, '%') }}</li>
      </ul>
    </div>

    <p
      style="background: #f8f9fc; height: 8px"
      :style="$route.query.themeStyleVs == 2 ? 'background:#0B0F14' : ''"
    ></p>

    <div style="padding: 15px" class="fenbu">
      <p class="title">
        <span>区间涨跌分布</span>
      </p>

      <div class="lsmx-day" ref="lsmxDay">
        <ul class="tab">
          <li
            v-for="(item, index) in periodArr"
            :key="index"
            :class="index === checkedIndex ? 'checkedClass' : ''"
            @click="handleClick(index)"
          >
            {{ item }}天
          </li>
        </ul>
      </div>

      <div class="pie" v-show="headerDown && RiseFallMap.length">
        <div class="left" id="pieData"></div>

        <ul class="right">
          <li v-for="(item, index) in pieExplain" :key="index">
            <p><i class="dot" :style="{ background: colorList[index] }"></i>{{ item.name }}</p>
            <p>
              {{ toFixedNum(RiseFallMap[index] * 100, 2, '%') }}
            </p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/index.js';
import { initiateDyzHc } from '@/api/create.js';
import {
  judgeColor,
  toFixedNum,
  formtTime,
  fangDouFun,
  getPreviousDay,
  getPreviousYear
} from '@/utils/format';

export default {
  name: 'AppDetailsNest',
  mixins: [mixin],
  data() {
    return {
      BacktestAnalysisResult: {},
      holdPeriodList: [],
      maxAvgSectionRateIndex: 0,
      maxRiseProbabilityIndex: 0,
      checkedIndex: 0,
      pieExplain: [
        {
          name: '大于7.5%'
        },
        {
          name: '3.5%到7.5%'
        },
        {
          name: '0到3.5%'
        },
        {
          name: '-3.5%到0%'
        },
        {
          name: '-3.5%到-7.5%'
        },
        {
          name: '小于-7.5%'
        }
      ],
      colorList: [
        'rgba(255, 99, 99, 1)',
        'rgba(255, 99, 99, 0.6)',
        'rgba(255, 99, 99, 0.4)',
        'rgba(47, 200, 123, 0.4)',
        'rgba(47, 200, 123, 0.6)',
        'rgba(47, 200, 123, 1)',
      ],
      RiseFallMap: [],
      myChart: null,
      hList: [],
      start: 1,
      loading: false,
      disabled: false,
      loadingText: '查看更多',
      periodArr: [],
      lsmxDayHeight: 0,
      headerDown: true,
      beginMaxDate: '',
      endMaxDate: ''
    };
  },
  components: {},
  filters: {},
  //计算属性
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.initiateDyzHcFun();
  },
  destroyed() {},
  methods: {
    judgeColor,
    toFixedNum,
    initiateDyzHcFun() {
      initiateDyzHc({
        factorList: this.$route.query.code,
        holdPeriodList: '1,2,3,5',
        code: this.$route.query.code,
        startDate: formtTime(new Date(getPreviousYear()), 'yyyyMMdd'),
        endDate: formtTime(new Date(getPreviousDay()), 'yyyyMMdd'),
        Mobile: 2
      })
        .then((res) => {
          this.BacktestAnalysisResult = res.data.BacktestAnalysisResult;
          res.data.BacktestAnalysisResult.forEach((i) => {
            this.holdPeriodList.push(i.HoldPeriod);
          });

          this.periodArr = this.holdPeriodList;
          this.RiseFallMap = JSON.parse(this.BacktestAnalysisResult[0].RiseFallMap);
          this.$nextTick(() => {
            this.chartFn();
          });

          var indices = this.getMaxIndices(
            this.BacktestAnalysisResult,
            'AvgSectionRate',
            'RiseProbability'
          );

          this.maxAvgSectionRateIndex = indices.maxAvgSectionRateIndex;
          this.maxRiseProbabilityIndex = indices.maxRiseProbabilityIndex;
        })
        .catch((err) => {
          this.$toast(err);
        });
    },

    //获取最大值AvgSectionRate(平均区间涨幅)和RiseProbability(上涨概率)最大值的索引用来高亮
    getMaxIndices: function (data, avgSectionRateKey, riseProbabilityKey) {
      let maxAvgSectionRateIndex = 0;
      let maxRiseProbabilityIndex = 0;
      let maxAvgSectionRate = data[0][avgSectionRateKey];
      let maxRiseProbability = data[0][riseProbabilityKey];

      for (let i = 1; i < data.length; i++) {
        if (data[i][avgSectionRateKey] > maxAvgSectionRate) {
          maxAvgSectionRate = data[i][avgSectionRateKey];
          maxAvgSectionRateIndex = i;
        }

        if (data[i][riseProbabilityKey] > maxRiseProbability) {
          maxRiseProbability = data[i][riseProbabilityKey];
          maxRiseProbabilityIndex = i;
        }
      }

      return {
        maxAvgSectionRateIndex,
        maxRiseProbabilityIndex
      };
    },

    handleClick: fangDouFun(function (...args) {
      this.handleTab(...args);
    }, 300),
    handleTab: function (index) {
      if (this.checkedIndex === index) return false;
      this.checkedIndex = index;
      this.RiseFallMap = JSON.parse(this.BacktestAnalysisResult[index].RiseFallMap);
      this.chartFn();
      this.start = 1;
    },
    chartFn: function () {
      var that = this;
      var chartDom = document.getElementById('pieData');
      if (that.myChart === null) {
        that.myChart = that.$echarts.init(chartDom);
      }

      var data = [];
      var arr = that.RiseFallMap.map((i, index) => {
        return (data[index] = {
          value: i * 100,
          name: ''
        });
      });

      var option = {
        series: [
          {
            type: 'pie',
            radius: '80%',
            color: that.colorList,
            data: data,
            emphasis: {
              scale: false // 禁止点击放大效果
            },
            label: {
              show: false // 隐藏坐标值
            }
          }
        ]
      };
      option && that.myChart.setOption(option);

      window.addEventListener('resize', function () {
        that.myChart.resize(); //自适应
      });
    }
  }
};
</script>
<style lang="less" scoped>
.appDetailsNest {
  min-height: 100vh;
  ::v-deep {
    .van-sticky {
      position: inherit !important;
    }
  }

  .mingxi {
    .title {
      display: flex;
      align-items: center;
      margin-bottom: 18px;
      .name {
        flex-shrink: 0;
      }
      p {
        font-weight: 600;
        font-size: 16px;
        color: rgba(0, 0, 0, 0.9);
      }
      .right {
        font-weight: 400;
        font-size: 12px;
        color: #999;
        margin-left: 2px;
      }
    }
    .fc-title-sticky {
      ::v-deep {
        .van-sticky--fixed {
          left: 15px;
          right: 15px;
        }
      }
    }
    .fc-title {
      display: flex;
      align-items: center;
      border-top: 1px solid #f0f0f0;
      padding: 4px 0;
      background: #fff;
      width: 100%;
      li {
        font-weight: 400;
        font-size: 12px;
        color: #999;
        &:nth-child(1) {
          width: 16%;
        }
        &:nth-child(2) {
          width: 21%;
        }
        &:nth-child(3) {
          width: 26%;
        }
        &:nth-child(4) {
          width: 21%;
        }
        &:nth-child(5) {
          width: 16%;
        }
      }
    }
    .zybox-list-left {
      // border: 1px solid red;
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      align-content: center;
      justify-content: flex-start;
      align-items: center;
    }

    .list {
      display: flex;
      align-items: center;
      border-top: 1px solid #f0f0f0;
      li {
        font-weight: 400;
        font-size: 14px;
        color: #555;
        padding: 12px 0;
        &:nth-child(1) {
          width: 16%;
        }
        &:nth-child(2) {
          width: 21%;
        }
        &:nth-child(3) {
          width: 26%;
        }
        &:nth-child(4) {
          width: 21%;
        }
        &:nth-child(5) {
          width: 16%;
        }

        .excellent,
        .probability {
          width: 18px;
          height: 30px;
          line-height: 14px;
          display: inline-flex;
          padding: 2px 3px;
          justify-content: center;
          align-items: center;
          gap: 10px;
          color: #fff;
          font-size: 10px;
          font-weight: 400;
          border-radius: 2px;
          margin-right: 4px;
        }
        .excellent {
          background: linear-gradient(270deg, #cd0000 0%, #f76825 100%);
        }
        .probability {
          background: linear-gradient(270deg, #e47813 0%, #ffbe5e 100%);
        }
      }

      &:last-child {
        border-bottom: 1px solid #f0f0f0;
      }
    }
  }

  .fenbu {
    .title {
      color: rgba(55, 58, 77, 0.9);
      font-size: 16px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .lsmx-day {
      ::v-deep {
        .van-sticky--fixed {
          left: 15px;
          right: 15px;
        }
      }
    }
    .tab {
      display: flex;
      align-items: center;
      background: #fff;
      padding: 4px 0;
      overflow-x: auto;
      li {
        height: 25px;
        left: 0px;
        top: 0px;
        background: #fff;
        border: 0.5px solid #f5f6f9;
        border-radius: 4px;
        padding: 0 14px;
        font-weight: 400;
        font-size: 12px;
        line-height: 25px;
        color: #555;
        margin-right: 9px;
        margin: 4px 4px 4px 0;
        flex-shrink: 0;
      }
      .checkedClass {
        background: #eaf1ff;
        border: 1px solid #eaf1ff;
        color: #286df7;
      }
    }
    .pie {
      display: flex;
      align-items: center;
      .left,
      .right {
        width: 50%;
        height: 142px;
        margin-top: 10px;
        li {
          p {
            font-weight: 400;
            font-size: 12px;
            color: #555;
          }
        }
      }

      .right {
        line-height: 24px;
        li {
          display: flex;
          align-items: center;
          justify-content: space-between;
          p {
            display: flex;
            align-items: center;
            .dot {
              width: 6px;
              height: 6px;
              border-radius: 50%;
              margin-right: 3px;
            }
          }
        }
      }
    }
    .lsmx {
      margin-top: 20px;
      line-height: 20px;
      .fc-title-sticky {
        ::v-deep {
          .van-sticky--fixed {
            left: 15px;
            right: 15px;
          }
        }
      }
      .title,
      .content-list {
        display: flex;
        align-items: center;
        background: #fff;
        li {
          width: 25%;
          font-weight: 400;
          font-size: 12px;
          color: #999;
          margin-bottom: 8px;
          &:nth-child(2),
          &:nth-child(3),
          &:nth-child(4) {
            text-align: right;
          }
          .StockName {
            font-weight: 600;
            font-size: 14px;
            color: #555;
          }
          .StockCode {
            font-weight: 400;
            font-size: 12px;
            color: #999;
          }
        }
      }
    }
    .all {
      height: 33px;
      background: rgba(40, 109, 247, 0.06) !important;
      border-radius: 4px;
      font-weight: 400;
      font-size: 12px;
      color: #286df7;
      width: 100%;
      border: none !important;
    }
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  background: #191a24 !important;
  .title {
    .name {
      color: #e4e9fe !important;
    }
    .right {
      color: #6b7687 !important;
    }
  }
  .list {
    .right {
      color: #e4e9fe !important;
    }
  }
  .fc-title-sticky {
    .fc-title {
      background: #191a24 !important;
      border-top: 1px solid #2f3139 !important;
      li {
        color: #6b7687 !important;
      }
    }
  }
  .list {
    border-top: 1px solid #2f3139 !important;
    &:last-child {
      border-bottom: 1px solid #2f3139 !important;
    }
    li {
      color: #e4e9fe !important;
    }
  }

  .title {
    span {
      color: #e4e9fe !important;
    }
  }
  .lsmx-day {
    .tab {
      background: #191a24 !important;
      li {
        border: 1px solid #46484f !important;
        background: #191a24 !important;
        color: #e4e9fe !important;
      }
      .checkedClass {
        border: 1px solid #1f2f4f !important;
        background: #1f2f4f !important;
      }
    }
  }
  .pie {
    .right {
      li {
        p {
          color: #e4e9fe !important;
        }
      }
    }
  }
  .lsmx {
    .fc-title-sticky {
      .title {
        background: #191a24 !important;
        li {
          color: #6b7687 !important;
        }
      }
    }
    .content-list {
      background: #191a24 !important;
      li,
      .StockName {
        color: #e4e9fe !important;
      }
      .StockCode {
        color: #6b7687 !important;
      }
    }
  }
}
</style>
